import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g id=\"bullet-list\"><g id=\"Vector\"><path d=\"M4.5 3C3.25736 3 2.25 4.00736 2.25 5.25C2.25 6.49264 3.25736 7.5 4.5 7.5C5.74264 7.5 6.75 6.49264 6.75 5.25C6.75 4.00736 5.74264 3 4.5 3Z\" fill=\"currentColor\"></path><path d=\"M9.75 4.5C9.33579 4.5 9 4.83579 9 5.25C9 5.66421 9.33579 6 9.75 6H15C15.4142 6 15.75 5.66421 15.75 5.25C15.75 4.83579 15.4142 4.5 15 4.5H9.75Z\" fill=\"currentColor\"></path><path d=\"M4.5 10.5C3.25736 10.5 2.25 11.5074 2.25 12.75C2.25 13.9926 3.25736 15 4.5 15C5.74264 15 6.75 13.9926 6.75 12.75C6.75 11.5074 5.74264 10.5 4.5 10.5Z\" fill=\"currentColor\"></path><path d=\"M9.75 12C9.33579 12 9 12.3358 9 12.75C9 13.1642 9.33579 13.5 9.75 13.5H15C15.4142 13.5 15.75 13.1642 15.75 12.75C15.75 12.3358 15.4142 12 15 12H9.75Z\" fill=\"currentColor\"></path></g></g>", 1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }